module.exports = __webpack_public_path__ + "img/code.526f384b.svg";